var uid = 0;
export default function uniqueId() {
    return uid++;
}
//# sourceMappingURL=uniqueId.js.map